// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PageWrapperSidebarDivider: React.FC<unknown> = (a = {}) => {
  return <hr className="my-3" />;
};
